import { createSelector } from 'reselect';
const selectAccount = (state) => state.account;
export const selectErrorMessagePayment = createSelector([selectAccount], (account) => account.licence.errorMessagePayment);
export const selectLoadingPayment = createSelector([selectAccount], (account) => account.licence.loadingPayment);
export const selectAccountUser = createSelector([selectAccount], (account) => account.user.user);
